module.exports = __webpack_public_path__ + "img/app-google-play-store.17615144.svg";